import type { Session } from 'src/shared/session';

import { getDigitFromId } from './getDigitFromId';
import { isGuest } from './isGuest';

export function isGuestInVariantGroup(session: Session, threshold: number) {
	return isGuest(session) && session.uuid && getDigitFromId(session.uuid) < threshold;
}
